<template>
    <MainLayout selectMenu="1-1" sideBar="machine" siderMenu="13-1">
        <div v-if="!hasAuth">
            <NoAuth></NoAuth>
        </div>
        <div v-else>
            <Tabs v-model="mode" type="card" class="custom-tabs">
                <TabPane :label="getTranslation('k003')" name="0" class="custom-tabpane">
                    <Card class="card-container " dis-hover>
                        <div slot="title" class="card-title">{{ getTranslation('k003') }}</div>
                        <Row class="limit-line" type="flex">
                            <Col flex="1">
                            <Row class="limit-line" type="flex">
                                <Col flex="1" class="left-program desc-field">{{ getTranslation('k213') }}</Col>
                                <Col flex="3"><Input class="input-field"  v-model="info.PartName" /></Col>
                            </Row>
                            </Col>
                            <Col flex="3">
                            <Row class="limit-line" type="flex">
                                <Col flex="1" class="left-program desc-field">{{ getTranslation('k172') }}</Col>
                                <Col flex="3"><Input class="input-long-field" v-model="info.BatchNumber" /></Col>
                            </Row>
                            </Col>
                        </Row>
                        <Row class="limit-line" type="flex">
                            <Col flex="1">
                            <Row class="limit-line" type="flex">
                                <Col flex="1" class="left-program desc-field">{{ getTranslation('k173') }}</Col>
                                <Col flex="3"><Input class="input-field" v-model="info.Worker" /></Col>
                            </Row>
                            </Col>
                            <Col flex="3">
                            </Col>
                        </Row>
                    </Card>
                    <Card class="card-container " dis-hover>
                        <div slot="title" class="card-title">{{ getTranslation('k069') }}</div>
                        <Row class="limit-line menu-actions" type="flex">
                            <Col flex="1">
                            <Row class="limit-line" type="flex">
                                <Col flex="1" class="left-program desc-field">{{ getTranslation('k174') }}</Col>
                                <Col flex="3"><Select :transfer="true" class="input-field"
                                    :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')"
                                    v-model="info.OptWeldSig1">
                                    <Option v-for="item in allLibrary" :value="item.ProgramId" :key="item.ProgramId">
                                        「{{ item.ProgramId }}」-{{ item.WeldProgram }}</Option>
                                </Select>&nbsp;
                                <Button type="success" size="small" icon="ios-eye-outline"
                                    @click.native="query(info.OptWeldSig1)">{{ getTranslation('k176') }}</Button></Col>
                            </Row>
                            </Col>
                            <Col flex="3">
                            <Row class="limit-line" type="flex">
                                <Col flex="1" class="left-program desc-field">{{ getTranslation('k177') }}</Col>
                                <Col flex="3">
                                <Select :transfer="true" class="input-long-field" :placeholder="getTranslation('m034')"
                                    v-model="info.OptProgramLinkStep" :not-found-text="getTranslation('b038')">
                                    <Option v-for="(item, key) in OptProgramLinkStepList" :value="key" :key="key">{{
                                        item }}</Option>
                                </Select>
                                </Col>
                            </Row>
                            </Col>
                        </Row>
                        <Row class="limit-line menu-actions" type="flex">
                            <Col flex="1">
                            <Row class="limit-line" type="flex">
                                <Col flex="1" class="left-program desc-field">{{ getTranslation('k175') }}</Col>
                                <Col flex="3"><Select :transfer="true" class="input-field"
                                    :placeholder="getTranslation('m034')" v-model="info.OptWeldSig2"
                                    :not-found-text="getTranslation('b038')">
                                    <Option v-for="item in allLibrary" :value="item.ProgramId" :key="item.ProgramId">
                                        「{{ item.ProgramId }}」-{{ item.WeldProgram }}</Option>
                                </Select>&nbsp;
                                <Button type="success" size="small" icon="ios-eye-outline" 
                                    @click.native="query(info.OptWeldSig2)">{{ getTranslation('k176') }}</Button></Col>
                            </Row>
                            </Col>
                            <Col flex="3">
                            <Row class="limit-line" type="flex">
                                <Col flex="1" class="left-program desc-field">{{ getTranslation('k178') }}</Col>
                                <Col flex="3"><Select :transfer="true" class="input-long-field"
                                    :placeholder="getTranslation('m034')" v-model="info.OptStartDlyFunc"
                                    :not-found-text="getTranslation('b038')">
                                    <Option v-for="(item, key) in SwitchList" :value="key" :key="key">{{ item }}</Option>
                                </Select></Col>
                            </Row>
                            </Col>
                        </Row>
                    </Card>
                    <Card class="card-container " dis-hover>
                        <div slot="title" class="card-title">{{ getTranslation('k179') }}</div>
                        <Row class="limit-line" type="flex">
                            <Col flex="1">
                            <Row class="limit-line" type="flex">
                                <Col flex="1" class="left-program desc-field">{{ getTranslation('k180') }}</Col>
                                <Col flex="3"><Select :transfer="true" class="input-field"
                                    :placeholder="getTranslation('m034')" v-model="info.OptStepCompFunc"
                                    :not-found-text="getTranslation('b038')">
                                    <Option v-for="(item, key) in SwitchList" :value="key" :key="key">{{ item }}</Option>
                                </Select></Col>
                            </Row>
                            </Col>
                            <Col flex="3">
                            <Row class="limit-line" type="flex">
                                <Col flex="1" class="left-program desc-field">{{ getTranslation('k182') }}</Col>
                                <Col flex="3"><Select :transfer="true" class="input-long-field"
                                    :placeholder="getTranslation('m034')" v-model="info.OptRepeatWeldFunc"
                                    :not-found-text="getTranslation('b038')">
                                    <Option v-for="(item, key) in SwitchList" :value="key" :key="key">{{ item }}</Option>
                                </Select></Col>
                            </Row>
                            </Col>
                        </Row>
                        <Row class="limit-line" type="flex">
                            <Col flex="1">
                            <Row class="limit-line" type="flex">
                                <Col flex="1" class="left-program desc-field">{{ getTranslation('k183') }}</Col>
                                <Col flex="3"><Select :transfer="true" class="input-field"
                                    :placeholder="getTranslation('m034')" v-model="info.OptIOMode"
                                    :not-found-text="getTranslation('b038')">
                                    <Option v-for="(item, key) in OptIOModeList" :value="key" :key="key">{{ item }}</Option>
                                </Select></Col>
                            </Row>
                            </Col>
                            <Col flex="3">
                            <Row class="limit-line" type="flex">
                                <Col flex="1" class="left-program desc-field">{{ getTranslation('k184') }}</Col>
                                <Col flex="3"><Input class="input-long-field" type="number"
                                    v-model="info.NumRepeatWeld" />
                                </Col>
                            </Row>
                            </Col>
                        </Row>
                        <Row class="limit-line" type="flex">
                            <Col flex="1">
                            <Row class="limit-line" type="flex">
                                <Col flex="1" class="left-program desc-field">{{ getTranslation('k185') }}</Col>
                                <Col flex="3"><Select :transfer="true" class="input-field"
                                    :placeholder="getTranslation('m034')" v-model="info.OptWeldSig2Func"
                                    :not-found-text="getTranslation('b038')">
                                    <Option v-for="(item, key) in SwitchList" :value="key" :key="key">{{ item }}</Option>
                                </Select></Col>
                            </Row>
                            </Col>
                            <Col flex="3">
                            </Col>
                        </Row>
                    </Card>
                    <div class="menu-actions">
                        <Button type="primary" icon="md-download"  size="small" @click.native="downloadProduction()">{{
                            getTranslation('k023')
                            }}</Button>&nbsp;
                    </div>

                </TabPane>
                <TabPane :label="getTranslation('k167')" name="1" class="custom-tabpane" :mode="mode">
                    <ElectrodeCountOne v-if="mode == 1"></ElectrodeCountOne>
                </TabPane>
                <TabPane :label="getTranslation('k168')" name="2" class="custom-tabpane" :mode="mode">
                    <ElectrodeCountTwo v-if="mode == 2"></ElectrodeCountTwo>
                </TabPane>
                <TabPane :label="getTranslation('k169')" name="3" class="custom-tabpane" :mode="mode">
                    <ElectrodeFixOne v-if="mode == 3"></ElectrodeFixOne>
                </TabPane>
                <TabPane :label="getTranslation('k170')" name="4" class="custom-tabpane" :mode="mode">
                    <ElectrodeFixTwo v-if="mode == 4"></ElectrodeFixTwo>
                </TabPane>
            </Tabs>
            <LibraryQuery v-model="modLibVisible" :propVisible="modLibVisible" :selectLibrary="modalQueryLib">
            </LibraryQuery>
        </div>
    </MainLayout>
</template>

<script>
import { API_URL } from '@/constants/const';
import axios from 'axios';
import MainLayout from '@/components/MainLayout.vue'
import { Tabs, TabPane, Card, Row, Col, Button, Select, Option, Input } from "view-design"
import ElectrodeCountOne from './components/ElectrodeCountOne.vue';
import ElectrodeCountTwo from './components/ElectrodeCountTwo.vue';
import ElectrodeFixOne from './components/ElectrodeFixOne.vue';
import ElectrodeFixTwo from './components/ElectrodeFixTwo.vue';
import { setSidbarBreadCrumb, postJsError, setDashboardPage } from '@/util/util.js';
import LibraryQuery from './components/LibraryQuery.vue';
import { mapGetters } from 'vuex'
import NoAuth from '@/components/NoAuth.vue'
export default {
    name: 'SystemIndex', // 组件名称
    components: {
        MainLayout, Tabs, TabPane, Card, Row, Col, Button, Select, Option, Input, ElectrodeCountOne, ElectrodeCountTwo, NoAuth,
        ElectrodeFixOne, ElectrodeFixTwo, LibraryQuery
    },
    computed: {
        ...mapGetters(['getTranslation']),
        OptProgramLinkStepList() {
            return [
                this.getTranslation("k048"),
                '1',
                '2',
                '3',
                '4',
                '5',
                '6',
                '7',
                '8',
                '9',
            ]
        },
        SwitchList() {
            return [
                this.getTranslation("k048"),
                this.getTranslation("k049"),
            ]
        },
        OptIOModeList() {
            return [
                this.getTranslation("k132"),
                this.getTranslation("k138"),
                this.getTranslation("k139"),
            ]
        },
        modalQueryLib() {
            return this.allLibrary[this.queryLib];
        }
    },
    watch: {
        mode(newVal) {            
            if(newVal){
                localStorage.setItem('production.selectTab', newVal);
            }
        }
    },
    data() {
        return {
            // 响应式数据  
            mode: 0,
            mac: '',
            info: {},
            allLibrary: [],
            selectLibraryId: -1,
            selectLibrary2Id: -1,
            poseField: {},
            modLibVisible: false,
            queryLib: -1,
            hasAuth: true,
        }
    },
    mounted() {

    },
    created() {
        // 生命周期钩子 - 实例创建后
        this.mode = localStorage.getItem('production.selectTab') || '0';
        this.init();
        setDashboardPage('production');
    },
    methods: {
        // 方法定义
        init() {
            let url = API_URL["productionInit"];
            this.mac = this.$route.query.mac
            if (!this.mac) {
                this.$Message.error(this.getTranslation('m041'));
                return
            }
            this.getInfo();
            let params = {
                mac: this.mac
            }
            axios.get(url, {
                params: params
            })
                .then(res => {
                    if (res && res.data && res.data.code == 200) {
                        this.allLibrary = res.data.data.library;
                        this.$nextTick(() => {
                            if (this.allLibrary.length > 0) {
                                this.selectLibraryId = 0;
                                this.selectLibrary2Id = 0;
                            }
                        })
                        this.$store.commit('setBreadcrumbItems', [
                            { title: setSidbarBreadCrumb(res.data.data.machine), machine: res.data.data.machine }
                        ]);
                    }
                })
                .catch((err) => {
                    postJsError(err)
                    this.$Message.error(this.getTranslation('c001'));
                })
        },
        getInfo() {
            let url = API_URL["productionInfo"];
            if (!this.mac) {
                this.$Message.error(this.getTranslation('m041'));
                return
            }
            let params = {
                mac: this.mac
            }
            axios.get(url, {
                params: params
            })
                .then(res => {
                    if (res && res.data && res.data.code == 200) {
                        this.info = res.data.data;
                        //this.$Message.success(res.data.msg);
                    } else if (res && res.data && res.data.code == 3001) {
                        this.hasAuth = false;
                    } else if (res && res.data && res.data.msg && this.mode == 0) {
                        this.$Message.error(res.data.msg);
                    }
                })
                .catch((err) => {
                    postJsError(err)
                    this.$Message.error(this.getTranslation('c001'));
                })
        },
        query(programId) {
            this.queryLib = programId
            this.modLibVisible = true;

        },
        downloadProduction() {
            let url = API_URL["ProductionManagerDownload"] + '?mac=' + this.mac
            let params = new FormData();
            this.info && Object.keys(this.info).forEach(key => {
                params.append(key, this.info[key]);
            });
            axios.post(url,
                params
            )
                .then(res => {
                    if (res && res.data && res.data.code == 200) {
                        this.$Message.success(res.data.msg);
                    } else if (res && res.data && res.data.msg) {
                        this.$Modal.error({
                        width: 50,
                        title: this.getTranslation("r098"),
                        content: res.data.msg.replace(/\n/g, '<br>'),
                        okText: this.getTranslation("m063"),
                        });
                    }
                })
                .catch((err) => {
                    postJsError(err)
                    this.$Message.error(this.getTranslation('c001'));
                })
        }
    }
}
</script>

<style scoped>
@import url('../../assets/style/list.css');
@import url('../../assets/style/tab.css');


.input-long-field {
    width: 30%;
}
</style>